import { jsx as _jsx } from "react/jsx-runtime";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Money } from "@faire/web--source/ui/Money";
import React from "react";
export var BrandMinimumInfo = function(param) {
    var brand_first_order_minimum = param.brand_first_order_minimum, brand_reorder_minimum = param.brand_reorder_minimum;
    if (brand_first_order_minimum !== undefined && brand_reorder_minimum !== undefined && brand_first_order_minimum.amount_cents !== brand_reorder_minimum.amount_cents) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "R6GLXJ",
            defaultMessage: [
                {
                    type: 1,
                    value: "brandMinimum"
                },
                {
                    type: 0,
                    value: " Min | "
                },
                {
                    type: 1,
                    value: "brandReorderMinimum"
                },
                {
                    type: 0,
                    value: " Reorder Min"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                brandMinimum: /*#__PURE__*/ _jsx(Money, {
                    omitCentsIfZero: true,
                    money: brand_first_order_minimum
                }),
                brandReorderMinimum: /*#__PURE__*/ _jsx(Money, {
                    omitCentsIfZero: true,
                    money: brand_reorder_minimum
                })
            })
        });
    }
    if ((brand_first_order_minimum === null || brand_first_order_minimum === void 0 ? void 0 : brand_first_order_minimum.amount_cents) === (brand_reorder_minimum === null || brand_reorder_minimum === void 0 ? void 0 : brand_reorder_minimum.amount_cents) && (brand_first_order_minimum === null || brand_first_order_minimum === void 0 ? void 0 : brand_first_order_minimum.amount_cents) === 0) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "eP2Bfr",
            defaultMessage: [
                {
                    type: 0,
                    value: "No Minimum"
                }
            ]
        });
    }
    if (brand_first_order_minimum !== undefined || brand_reorder_minimum !== undefined) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "89n5SV",
            defaultMessage: [
                {
                    type: 1,
                    value: "brandMinimum"
                },
                {
                    type: 0,
                    value: " Minimum"
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                brandMinimum: /*#__PURE__*/ _jsx(Money, {
                    omitCentsIfZero: true,
                    money: brand_first_order_minimum || brand_reorder_minimum
                })
            })
        });
    }
    return null;
};
